import React, { useEffect, useState } from 'react';
import { CButton, CCard, CHeader, CRow, CCol, CImage } from '@coreui/react';
import Moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { getTransactionListById } from 'src/services/Transactions';
import formatter from 'src/reusables/formatter';
import { getVoucherDetail } from 'src/services/Voucher/Voucher';
import ls from 'local-storage';

function VoucherUsageDetails() {
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(0);

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);
  const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');
  const [voucher, setVoucher] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  
  const navigate = useNavigate();
  const location = useLocation();

  async function fetchVoucherDetail(id) {
    const res = await getVoucherDetail(ls.get("booth")?.id, id);
    const currentVoucher = res.data.filter((item) => item.id === ls.get("stateVoucher").trxId)
    setVoucher(currentVoucher[0]);
    setVouchers(res.data)
  }

  useEffect(() => {
    if ((refetch && renderCounter > 0) || renderCounter === 0) {
      fetchVoucherDetail(ls.get("stateVoucher").voucherId);
      setRefetch(false);
    }

    setRenderCounter(renderCounter + 1);
  }, [refetch]);

  return (
    <div style={{ color: 'black' }}>
      <CCol>
        <CButton
          className="ml-3 mb-3 btn btn-dark"
          style={{ backgroundColor: '#4E5B97', border: 'none' }}
          hover="true"
          onClick={() => {
            ls.remove("stateVoucher")
            navigate('/voucher-usage');
          }}
        >
          Back
        </CButton>
      </CCol>
      <CCard>   
        {/* <CRow style={{ padding: '2vh 3vw' }}> */}
        <CHeader style={{ fontSize: '30px', padding: '1vh 2vw'}}>Voucher Usage Detail: </CHeader>
        {/* </CRow> */}
      </CCard>
      <CCard style={{marginTop:"2vh"}}>
        {/* <CRow style={{ padding: '2vh 3vw' }}> */}
        <CHeader style={{ fontSize: '18px', padding: '1vh 2vw' }}>Voucher Detail: </CHeader>
        {/* </CRow> */}
      </CCard>
      <CCard style={{ textAlign: 'left', padding: '2vh 3vw' }}>
          <CCol xs="12">
            <CRow>
                <CCol>Valid From</CCol>
                <CCol>{formatter("timestampDate", voucher?.valid_from)}</CCol>
            </CRow>
            <CRow>
                <CCol>Valid Until</CCol>
                <CCol>{formatter("timestampDate", voucher?.valid_until)}</CCol>
            </CRow>
            <CRow>
                <CCol>Issuer Name</CCol>
                <CCol>{voucher?.issuer_name}</CCol>
            </CRow>
            <CRow>
                <CCol>Discount Type</CCol>
                <CCol>{voucher?.discount_type === "percentage" ? "Percentage" : "Nominal"}</CCol>
            </CRow>
            <CRow>
                <CCol>Discount Amount</CCol>
                <CCol>{voucher?.discount_type === "percentage" ? `${voucher?.discount_amount}%` : `Rp ${voucher?.discount_amount}`}</CCol>
            </CRow>
            <CRow>
                <CCol>Merchant Name</CCol>
                <CCol>{voucher?.merchant_id === 0 || voucher?.merchant_id === "0" ? `All Merchant` : `${voucher?.merchant_name}`}</CCol>
            </CRow>
            <CRow>
                <CCol>Used Count</CCol>
                <CCol>{voucher?.used_count}</CCol>
            </CRow>
            <CRow>
                <CCol>Usage Count</CCol>
                <CCol>{voucher?.usage_count}</CCol>
            </CRow>
            <CRow>
                <CCol>Use Rate</CCol>
                <CCol>{(voucher?.used_count/voucher?.usage_count * 100).toFixed(2)}%</CCol>
            </CRow>
          </CCol>
      </CCard>
        {/* <CRow> */}
            <CHeader style={{ fontSize: '18px', marginTop: '3vh', padding: '1vh 2vw' }}>Transaction Detail: </CHeader>
        {/* </CRow> */}
      <CCard style={{ textAlign: 'left', padding: '2vh 3vw' }}>
        <CCol xs="12">
            <CRow>
                <CCol>ID</CCol>
                <CCol>{voucher?.id}</CCol>
            </CRow>
            <CRow>
                <CCol>Paid At</CCol>
                <CCol>{voucher?.paidAt ? formatter('completeDate', voucher?.paidAt) : '-'}</CCol>
            </CRow>
            <CRow>
                <CCol>Done At</CCol>
                <CCol>{voucher?.doneAt ? formatter('completeDate', voucher?.doneAt) : '-'}</CCol>
            </CRow>
            <CRow>
                <CCol>Duration</CCol>
                <CCol>{voucher?.duration ?? '0'} Minutes</CCol>
            </CRow>
            <CRow>
                <CCol>Price</CCol>
                <CCol>{formatter('currency', voucher?.price ?? 0)}</CCol>
            </CRow>
            <CRow>
                <CCol>Discount</CCol>
                <CCol>{formatter('currency', voucher?.discount ?? 0)}</CCol>
            </CRow>
            <CRow>
                <CCol>Grand Total</CCol>
                <CCol>{formatter('currency', voucher?.grand_total ?? 0)}</CCol>
            </CRow>
            <CRow>
                <CCol>Voucher Code</CCol>
                <CCol>{voucher?.voucherCode}</CCol>
            </CRow>

            <CRow>
                <CCol>Frame</CCol>
                <CCol>{voucher?.frameName ?? '-'}</CCol>
            </CRow>
            <CRow>
                <CCol>Timeout</CCol>
                <CCol>{voucher?.timeout === 1 ? 'Yes' : 'No'}</CCol>
            </CRow>
            <CRow>
                <CCol>Image</CCol>
                <CCol>
                    {voucher?.imageURL ? 
                    (voucher?.imageURL?.includes('Failed To Upload') ? (
                    <p>{voucher?.imageURL}</p>
                    ) : (
                    <CImage width="300vh" src={voucher?.imageURL ?? ''} />
                    )) :
                    "-"}
                </CCol>
            </CRow>
        </CCol>
      </CCard>
    </div>
  );
}

export default VoucherUsageDetails;
